export const joinString = (data: string[]) => data.filter(Boolean).join("_")
